import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../axios/axiosInstance';
import { showToast } from './ToastSlice';


export const getFaqs = createAsyncThunk('faq/get', async (_, thunkAPI) => {
  try {
    const res = await api.get('/faq/get');
    
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || 'Failed to fetch FAQs');
  }
});


export const saveFaq = createAsyncThunk('faq/saveFaq', async (faqData, thunkAPI) => {
  try {
    const response = await api.post('/faq/addEdit', faqData);

    thunkAPI.dispatch(
      showToast({
        message: response.data.message,
        variant: "success",
      })
    );
    return response.data.data;
  } catch (err) {
     thunkAPI.dispatch(
      showToast({
        message: err.response.data.message,
        variant: "danger",
      })
    );
    return thunkAPI.rejectWithValue(err.response?.data || 'Failed to save FAQ');
  }
});

export const deleteFaq = createAsyncThunk('faq/delete', async (faqId, thunkAPI) => {
  try {
    
   const response = await api.delete('/faq/delete', {  data: { faqId}, });


   thunkAPI.dispatch(
      showToast({
        message: response.data.message || "FAQs fetched successfully!",
        variant: "success",
      })
    );

    return faqId;
  } catch (err) {
    thunkAPI.dispatch(
      showToast({
        message: err.response.data.message,
        variant: "danger",
      })
    );
    return thunkAPI.rejectWithValue(err.response?.data || 'Failed to delete FAQ');
  }
});

const faqSlice = createSlice({
  name: 'faq',
  initialState: {
    faqs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFaqs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFaqs.fulfilled, (state, action) => {
        state.loading = false;
        state.faqs = action.payload;
      })
      .addCase(getFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(saveFaq.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveFaq.fulfilled, (state, action) => {
        state.loading = false;
        const updatedFaq = action.payload;
        const index = state.faqs.findIndex(f => f._id === updatedFaq._id);
        if (index !== -1) {
          state.faqs[index] = updatedFaq;
        } else {
          state.faqs.push(updatedFaq);
        }
      })
      .addCase(saveFaq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteFaq.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFaq.fulfilled, (state, action) => {
        state.loading = false;
        state.faqs = state.faqs.filter(f => f._id !== action.payload);
      })
      .addCase(deleteFaq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default faqSlice.reducer;
